export default __webpack_public_path__ + "static/myfriend-a5709672e1c3ca6569ebe5be3fa81fbe.jpeg";